<script>
import RecordImageList from './image-list'
import _ from 'lodash'
import RecordImageClassifyService from '@/request/record/recordImageClassify'
export default {
  name: 'RecordRecordImageList',
  components: {
    RecordImageList
  },
  props: {
    record: [Object, Number],
    disabled: {
      type: Boolean,
      default: true
    },
    enableAdd: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      imageOptions: {
        id: null,
        source: 'record',
        classify: 0,
        disabled: false
      },
      classifys: [],
      visibleEditImage: false,
      fileList: [],
      showFileView: false,
      fileIndex: null
    }
  },
  computed: {},
  mounted () {},
  beforeDestroy () {},
  watch: {
    record (val) {
      if (val.oid && val.hid) {
        this.listRecordImageClassify()
      }
    }
  },
  methods: {
    listRecordImageClassify () {
      const defClassifys = [{ classify: 0, name: '术前' }, { classify: 1, name: '术中' }, { classify: 2, name: '术后' }]
      const promiseAll = []
      promiseAll.push(this.loadRecordImageClassify(this.record.oid))
      promiseAll.push(this.loadRecordImageClassify(this.record.hid))
      Promise.all(promiseAll).then((res) => {
        for (let i = 0; i < res.length; i++) {
          if (res[i].length > 0 ) {
            _.forEach(res[i], item => {
              if (item.classify === 0) {
                defClassifys[0].name = item.name || '术前'
              } else if (item.classify === 1) {
                defClassifys[1].name = item.name || '术中'
              } else if (item.classify === 2) {
                defClassifys[2].name = item.name || '术后'
              }
            })
            break
          }
        }
        this.classifys = defClassifys
      }).catch(() => {
        this.classifys = defClassifys
      })
    },
    loadRecordImageClassify (oid) {
      return new Promise((resolve) => {
        if (!oid) {
          return
        }
        RecordImageClassifyService.list({
          oids: oid
        }).then(res => {
          resolve(res.result || [])
        })
      })
    },
    handleEditImage (data) {
      _.forEach(data, (value, key) => {
        this.$set(this.imageOptions, key, value)
      })
      this.visibleEditImage = true
    },
    handleCancelEditImage () {
      let name = 'images_' + this.imageOptions.source + '_' + this.imageOptions.id
      if (this.imageOptions.source === 'record') {
        name += '_' + this.imageOptions.classify
      }
      this.$refs[name] && this.$refs[name].listImage()
      this.imageOptions = {
        id: null,
        source: 'record',
        classify: 0,
        disabled: false
      }
    },
    // 查看病历图片
    showRecordImags (ev) {
      this.$nextTick(() => {
        const files0 = this.$refs['images_record_' + this.record.id + '_0'].files || []
        const files1 = this.$refs['images_record_' + this.record.id + '_1'].files || []
        const files2 = this.$refs['images_record_' + this.record.id + '_2'].files || []
        const _fileList = _.concat(files0, files1, files2)
        for (let i = 0; i < _fileList.length; i++) {
          if (this.fileList.length === 0 || !this.fileList[i] || this.fileList[i] !== _fileList[i]) {
            this.fileList = _fileList
            break
          }
        }
        if (ev.classify === 0) {
          this.fileIndex = ev.index
        }
        if (ev.classify === 1) {
          this.fileIndex = files0.length + ev.index
        }
        if (ev.classify === 2) {
          this.fileIndex = files0.length + files1.length + ev.index
        }
        this.showFileView = true
      })
    }
  },
  filters: {}
}
</script>

<template>
  <div class="image-list-wrap">
    <div class="record-images-header clear">
      <span>{{classifys[0] ? classifys[0].name : '术前'}}图片</span>
      <el-button v-if="enableAdd" type="text" style="float: right;" @click="handleEditImage({id: record.id, classify: 0})">编辑</el-button>
    </div>
    <div class="record-images-box record-images-box-0 flex-disply">
      <el-scrollbar class="flex-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
        <record-image-list
          :showImages="false"
          @preView="showRecordImags"
          :ref="'images_record_' + record.id + '_0'"
          :source-id="record.id"
          :classify="0"
          :disabled="disabled"
          :enable-add="enableAdd"
          :mark="record.hname">
        </record-image-list>
      </el-scrollbar>
    </div>
    <div class="record-images-header clear">
      <span>{{classifys[1] ? classifys[1].name : '术中'}}图片</span>
      <el-button v-if="enableAdd" type="text" style="float: right;" @click="handleEditImage({id: record.id, classify: 1})">编辑</el-button>
    </div>
    <div class="record-images-box record-images-box-0 flex-disply">
      <el-scrollbar class="flex-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
        <record-image-list
          :showImages="false"
          @preView="showRecordImags"
          :ref="'images_record_' + record.id + '_1'"
          :source-id="record.id"
          :classify="1"
          :disabled="disabled"
          :enable-add="enableAdd"
          :mark="record.hname">
        </record-image-list>
      </el-scrollbar>
    </div>
    <div class="record-images-header clear">
      <span>{{classifys[2] ? classifys[2].name : '术后'}}图片</span>
      <el-button v-if="enableAdd" type="text" style="float: right;" @click="handleEditImage({id: record.id, classify: 2})">编辑</el-button>
    </div>
    <div class="record-images-box record-images-box-0 flex-disply">
      <el-scrollbar class="flex-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
        <record-image-list
          :showImages="false"
          @preView="showRecordImags"
          :ref="'images_record_' + record.id + '_2'"
          :source-id="record.id"
          :classify="2"
          :disabled="disabled"
          :enable-add="enableAdd"
          :mark="record.hname">
        </record-image-list>
      </el-scrollbar>
    </div>
    <eber-photo-viewer
      v-show="showFileView"
      :images="fileList"
      :show-index="fileIndex"
      @close="showFileView=false">
    </eber-photo-viewer>
    <!-- 编辑图片 -->
    <el-dialog title="编辑图片" :visible.sync="visibleEditImage" @close="handleCancelEditImage" :close-on-click-modal="false">
      <record-image-list
        v-if="visibleEditImage"
        :source-id="imageOptions.id"
        :classify="imageOptions.classify"
        :enable-add="true"
        :mark="record.hname"
        :disabled="imageOptions.disabled"
      ></record-image-list>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="visibleEditImage = false">完成</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.image-list-wrap {
  width: 100%;
  height: auto;
}
.record-images-header {
  line-height: 38px;
  padding: 0 10px;
  /*border-top: 1px solid #ebeef5;*/
  /*border-bottom: 1px solid #ebeef5;*/
  margin-bottom: 5px;
}
.record-images-header {
  line-height: 38px;
  padding: 0 10px;
}
.record-images-box {
  min-height: 160px;
  max-height: 340px;
  /*border-right: 1px solid #ebebeb;*/
}
.record-images-box.record-images-box-1,
.record-images-box.record-images-box-2 {
  /*border-left: 1px solid #F2F6FC;*/
}
</style>
